export function formatCurrency(val) {
  if (!val && val !== 0) return '—';
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(val);
}

export function formatDate(val) {
  if (!val) return '—';
  try {
    const d = new Date(val + 'T00:00:00');
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  } catch { return val; }
}

export function formatDateShort(val) {
  if (!val) return '—';
  try {
    const d = new Date(val + 'T00:00:00');
    return d.toLocaleDateString('en-US', { month: 'numeric', day: 'numeric', year: '2-digit' });
  } catch { return val; }
}

export function getStatusBadgeClass(status) {
  if (!status) return 'badge badge-closed';
  const s = status.toLowerCase();
  if (s === 'active') return 'badge badge-active';
  if (s === 'cancelled') return 'badge badge-cancelled';
  if (s.includes('funded') || s.includes('complete')) return 'badge badge-funded';
  if (s === 'on-site') return 'badge badge-on-site';
  if (s === 'hold') return 'badge badge-hold';
  if (s === 'closed') return 'badge badge-closed';
  if (s === 'due') return 'badge badge-due';
  if (s === 'collected') return 'badge badge-collected';
  return 'badge badge-closed';
}

export function getServiceFromJob(job) {
  return job.svc1 || job.svc2 || job.svc3 || job.svc4 || '—';
}

export const MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
